import React from 'react';
import { withStyles, withTheme } from '@material-ui/styles';

const useStyles = theme => ({
  alignment: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
  main: {
    top: '50%',
    left: 'calc(50% - 30px)',
    position: "fixed",
    zIndex: 9999
  },
  mainRelative: {
    marginTop: '16px',
    position: "relative",
    zIndex: 9999
  },
  resetTransformScale: {
    margin: "16px 0"
  },
  circularLoader: {
    scale: 1,
    animation: '$isRotating 1s infinite',
    borderRadius: '50%',
    width: '60px',
    height: '60px',
    border: '4px solid #e5e5e5',
    borderTopColor: theme.palette.background.iconContrastSecondary,
  },
  loaderText: {
    color: '#1351b4',
    fontSize: '14px'
  },
  '@keyframes isRotating': {
    to: {
      transform: 'rotate(1turn)',
    },
  }
});

const LoadingCircular = props => {

  let { classes, text, positionRelative } = props;

  let mainStyle = !positionRelative ? `${classes.alignment} ${classes.main}` : `${classes.alignment} ${classes.mainRelative}`

  return (
    <div id="circularLoader" className={mainStyle}>
      <div className={classes.circularLoader}></div>
      {text && (
        <p className={classes.resetTransformScale}>{text}</p>
      )}
    </div>
  )
}

export default (withStyles(useStyles)(withTheme(LoadingCircular)));
